import { AdCampaignTypeEnum } from '@entities/media';

import type { ICreateAdCampaignState } from './types';

export const CREATE_AD_CAMPAIGN_SLICE_NAME = 'createAdCampaign';

export enum CREATE_AD_CAMPAIGN_STEPS {
  SETTINGS = 'SETTINGS',
  MEDIA = 'MEDIA',
  POINTS = 'POINTS',
}

export const createAdCampaignDefaultState: ICreateAdCampaignState = {
  step: CREATE_AD_CAMPAIGN_STEPS.SETTINGS,
  mediaType: null,
  campaignType: AdCampaignTypeEnum.Interval,
  campaignName: '',
  valueByMode: '30',
  startDate: null,
  endDate: null,
  isInfinitely: false,
  weekdays: {
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true,
    sunday: true,
  },
  dayStartTime: '00:00',
  dayEndTime: '23:59',
  selectedTags: [],
  selectedPointIds: [],
  promoStatuses: [],
  promoTimesById: {},
};
